
export default {
    name: 'GermanLogos',

    data() {
        return {
            logos: [
                {
                    url: 'https://www.trustedshops.de/bewertung/info_X127D2021B95D1F24183C8355ECFEDFF3.html',
                    name: 'Trusted Shops',
                    file: require('~assets/images/trusted-shops-logo.avif'),
                    width: '926',
                    height: '382',
                },
                {
                    url: 'https://www.handelsverband.at/mitglieder-partner/unsere-partner/detail/orderchamp/',
                    name: 'Handelsverband Mitglied',
                    file: require('~assets/images/handelsverband-mitglied.avif'),
                    width: '200',
                    height: '120',
                },
                {
                    url: 'https://einzelhandel.de/',
                    name: 'HDE Handelsverband Deutschland',
                    file: require('~assets/images/hde-handelsverband-deutschland.avif'),
                    width: '383',
                    height: '132',
                },
            ]
        }
    },
}
